var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"con-info"},[_c('div',{staticClass:"h-100 ns-info",staticStyle:{"min-height":"100vh"}},[_c('SyaratAda')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }